import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import { Multiselect } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';

const renderMultiselect = ({ input, data, valueField, textField, meta: { touched, error }, fetcher }) =>
  <div className="u-position-relative">
    <Multiselect
      {...input}
      onBlur={() => input.onBlur()}
      value={input.value || []} // requires value to be an array
      data={data}
      valueField={valueField}
      textField={textField}
      filter="contains"
      groupBy="shop"
      onSearch={fetcher}
      messages={{
        emptyList: 'Type barber name to begin',
      }}
    />
    {touched && error && <div className="c-input-error-message">{error}</div>}
  </div>;

const BarberSelect = ({ barbers, fetcher }) => {
  return (
    <Field
      name="barbers"
      component={renderMultiselect}
      data={barbers}
      valueField="id"
      textField="name"
      fetcher={fetcher}
    />
  );
};

BarberSelect.propTypes = {
  barbers: PropTypes.array.isRequired,
  fetcher: PropTypes.func.isRequired,
};

export default BarberSelect;
